import { render, staticRenderFns } from "./ShowAnnouncement.vue?vue&type=template&id=135cda3d&scoped=true"
import script from "./ShowAnnouncement.vue?vue&type=script&lang=js"
export * from "./ShowAnnouncement.vue?vue&type=script&lang=js"
import style0 from "./ShowAnnouncement.vue?vue&type=style&index=0&id=135cda3d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "135cda3d",
  null
  
)

export default component.exports